<template>
  <div>
    <video ref="player" class="video-js"></video>
  </div>
</template>

<script>
import videojs from 'video.js'

const EVENTS = ['play', 'pause', 'waiting', 'playing', 'ended', 'error']

export default {
  name: 'VideoPlayer',
  props: {
    source: {
      type: String
    },
    poster: {
      type: String
    },
    loop: {
      type: Boolean,
      default: () => false
    },
    options: {
      type: Object,
      default: () => {}
    },
    playing: {
      type: Function
    },
    paused: {
      type: Function
    },
    ended: {
      type: Function
    }
  },
  data() {
    return {
      player: null
    }
  },
  methods: {},
  watch: {
    source() {
      if (this.source) {
        this.player.src(this.source)
      } else {
        this.player.pause()
        this.player.currentTime(0)
        this.player.src(this.source)
      }
    },
    poster() {
      if (this.poster) {
        this.player.poster(this.poster)
      }
    },
    loop() {
      this.player.loop(this.loop)
    }
  },
  mounted() {
    const self = this
    this.player = videojs(this.$refs.player, this.options, function() {
      for (const event of EVENTS) {
        ;(event => {
          this.on(event, () => {
            self.$emit(event, this.player)
          })
        })(event)
      }

      self.$emit('ready', this)
    })
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
    }
  }
}
</script>
